// 2023.07.13 New Standard API
// import  _ from 'lodash'
import qs from 'qs'
import {$swoole} from './axios.setup'
// getStandards
export const getStandards = async ({params} = {}) => {
  const url = '/v1/cars'

  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}

// getBrandsOfStandards
export const getBrandsOfStandards = async ({params} = {}) => {
  const url = '/v1/filter-param-brand-new'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}

// getProvincesOfStandard
export const getProvincesOfStandard = async ({params} = {}) => {
  const url = '/v1/filter-param-province'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}

// getSubstationOfStandard
export const getSubstationOfStandard = async ({params} = {}) => {
  const url = '/v1/filter-param-substations'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}

// getStandard
export const getStandard = async ({params} = {}) => {
  const url = `/v1/car/${params.id}`
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}

// retrieveStandardReportEquipment
export const retrieveStandardReportEquipment = async ({params}) => {
  const url = '/v1/car/configurationChecklist'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}

// getStandardRecommends
// - 2023.08.16
// - get standard recommends
export const getStandardRecommends = async ({params}) => {
  const url = '/v1/likes'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}

// getStandardMileageReport
// - 2023.08.16
// - get standard report mileage
export const getStandardMileageReport = async ({params}) => {
  const url = '/v1/vehicleInspection/mileage/'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}

// getStandardMerchandise
// - 2025.02.10
// - get standard merchandise
export const getStandardMerchandise = async () => {
  const url = '/v1/other/youZanGoods'
  const res = await $swoole.get(url)

  return res.data.data
}

// getStandardVehicleRating
// - 2025.02.11
// - Get vehicle condition rating levels
export const getStandardVehicleRating = async ({params} = {}) => {
  const url = '/v1/filter-param-condition-levels'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}

// getStandardSListsParamsExteriorColors
// - 2025.03.24
// - Get exterior color filter options
export const getStandardSListsParamsExteriorColors = async ({params} = {}) => {
  const url = '/v1/filter-param-exterior-colors'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}

// getMomentDetailIdByCarId
// - 2024.05.31
// - Get moment detail id by car id
export const getMomentDetailIdByCarId = async ({params} = {}) => {
  const url = '/v1/nuoCircle/list'
  const body = qs.stringify(params)
  const res = await $swoole.post(url, body, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })

  return res.data.data
}
